import BillManagerProductIntroScreen from 'features/billManager/screens/BillManagerProductIntro/BillManagerProductIntroScreen';
import React from 'react';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

export default function BillManagerLandingPage() {
  return (
    <PinwheelContextProvider>
      <BillManagerProductIntroScreen />
    </PinwheelContextProvider>
  );
}
